"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MessageOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var MessageOutlineSVG = function MessageOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M27 4H5a3 3 0 00-3 3v12a3 3 0 003 3h3v6a1 1 0 000 .4 1 1 0 00.6.5 1 1 0 00.8 0 1 1 0 00.3-.2l6.7-6.7H27a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H16a1 1 0 00-.7.3L10 25.6V22a2 2 0 00-2-2H5a1 1 0 01-1-1V7a1 1 0 011-1h22a1 1 0 011 1z"
  }));
};
exports.MessageOutlineSVG = MessageOutlineSVG;
MessageOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(MessageOutlineSVG);
exports.default = _default;